import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-left">
            <div className="footer-logo">
              <span className="footer-bracket">&lt;</span>
              <span className="footer-logo-text">SLS</span>
              <span className="footer-bracket">/&gt;</span>
            </div>
            <p className="footer-legal">Second Life Software LLC</p>
          </div>
          <div className="footer-right">
            <a href="/design" className="footer-link">
              Design
            </a>
            <a href="/privacy.html" className="footer-link">
              Privacy
            </a>
            <a href="/terms.html" className="footer-link">
              Terms
            </a>
            <a href="mailto:info@secondlifesoftware.com" className="footer-email">
              info@secondlifesoftware.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
